<template>
<div class="flex justify-end items-center relative z-30">
  <div>
    <custom-general-select :options="localeNames" v-model="selectedLocale"
      :isLarge="false" :hasOverflow="false"
      button-bg-color="bg-whit" options-bg-color="bg-white" />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import CustomGeneralSelect from './CustomGeneralSelect.vue';

export default {
  components: { CustomGeneralSelect },
  props: ['options'],

  data() {
    return {
      selectedLocale: this.options.find((opt) => opt.code === this.$i18n.locale).name,
    };
  },

  watch: {
    selectedLocale() {
      this.updateLocale();
    },
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      isTeacher: 'auth/isTeacher',
      user: 'auth/user',
    }),
    localeNames() {
      return this.options.map((opt) => opt.name);
    },
  },

  methods: {
    ...mapActions({
      changeLocale: 'auth/changeLocale',
    }),

    updateLocale() {
      this.$i18n.locale = this.options.find((opt) => opt.name === this.selectedLocale).code;
      this.changeLocale();
      this.$store.dispatch('auth/auth');
      if (this.user) {
        this.updateUserLocale(this.$i18n.locale);
      }
    },

    updateUserLocale(locale) {
      axios.put(`/api/users/${this.user.id}`, { lang: locale }).then(() => {
        this.$store.dispatch('auth/me');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>
